import React from "react";
import { Inbox, AlertCircle } from "lucide-react";

export function Spinner({ className = "h-5 w-5", label }) {
  return (
    <span role="status" className="inline-flex items-center gap-2">
      <span className={`animate-spin rounded-full border-2 border-current border-t-transparent ${className}`} />
      <span className={label ? "text-sm" : "sr-only"}>{label || "Loading"}</span>
    </span>
  );
}

export function LoadingState({ label = "Loading...", className = "" }) {
  return (
    <div className={`flex items-center justify-center py-12 text-gray-500 ${className}`}>
      <Spinner className="h-6 w-6 text-blue-600" label={label} />
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", message, icon: Icon = Inbox, action, className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}>
      <Icon className="h-10 w-10 text-gray-300 mb-3" />
      <p className="font-medium text-gray-700">{title}</p>
      {message && <p className="mt-1 text-sm text-gray-500 max-w-sm">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong.", onRetry, className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}>
      <AlertCircle className="h-10 w-10 text-red-300 mb-3" />
      <p className="text-sm text-gray-700 max-w-sm">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 px-4 py-2 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Try again
        </button>
      )}
    </div>
  );
}
